import { render } from "./searchPageSidebar.vue?vue&type=template&id=242b1eaf&ts=true"
import script from "./searchPageSidebar.vue?vue&type=script&lang=ts"
export * from "./searchPageSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__